export class SignUp {
  Username: string;
  CompanyName: string;
  Email: string;
}
